import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {OperationalContactModel} from "../../../commons/angular/models/operational-contact.model";
import {SplitService} from "../../../commons/services/split-service.service";

export class ServiceOperationalContactsTableRowComponent implements IController {
  operationalContact: OperationalContactModel;
  index: number;
  onRemove: Function;
  onChange: Function;
  form: any;

  public siteOperationalContactTypes: string[];

  /* @ngInject */
  constructor(private splitService: SplitService) {
    this.siteOperationalContactTypes = this.splitService.getOperationalContactTypes();
  }

  $onInit() {

  }

  $onChanges(changes: angular.IOnChangesObject) {

  }

  onChangeContactName(name: string) {
    const operationalContactCopy: OperationalContactModel = angular.copy(this.operationalContact);
    operationalContactCopy.name = name;
    this.onChange({operationalContact: operationalContactCopy});
  }

  onChangeContactType(contactType: string) {
    const operationalContactCopy: OperationalContactModel = angular.copy(this.operationalContact);
    operationalContactCopy.contactType = contactType;
    this.onChange({operationalContact: operationalContactCopy});
  }

  onPhoneChange(phoneNo: string) {
    const operationalContactCopy: OperationalContactModel = angular.copy(this.operationalContact);
    operationalContactCopy.phoneNo = phoneNo;
    this.onChange({operationalContact: operationalContactCopy});
  }


  // private _setQuantityValidity() {
  //   this.form[this.quantityFieldName].$setValidity('valid', this.quantityLeft > -1);
  // }

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceOperationalContactsTableRow', {
    require: {
      form: '^form'
    },
    bindings: {
      operationalContact: '<?',
      index: '<',
      onRemove: '&',
      onChange: '&',
    },
    template: require('./service-operational-contacts-table-row.html').default,
    controller: ServiceOperationalContactsTableRowComponent
  });
